import type { SVGProps } from 'react'
const SvgSyLock = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M11.873 2a5.31 5.31 0 0 0-5.32 5.277v2.17a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V7.281A3.787 3.787 0 0 1 11.869 3.5h.004a3.79 3.79 0 0 1 3.8 3.8v2.147a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V7.301c0-2.918-2.38-5.3-5.298-5.301z"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M8.043 8.627c-2.5 0-4.543 2.04-4.543 4.541v4.289C3.5 19.957 5.544 22 8.043 22h7.64c2.5 0 4.542-2.043 4.542-4.543v-4.289c0-2.5-2.042-4.541-4.541-4.541zm0 1.5h7.64a3.03 3.03 0 0 1 3.042 3.041v4.289a3.03 3.03 0 0 1-3.041 3.043H8.043A3.03 3.03 0 0 1 5 17.457v-4.289a3.03 3.03 0 0 1 3.043-3.041"
				clipRule="evenodd"
			/>
			<path d="M11.863 13.453a.75.75 0 0 0-.75.75v2.22a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-2.22a.75.75 0 0 0-.75-.75" />
		</g>
	</svg>
)
export default SvgSyLock
